import React from 'react'

import { Checkbox, FormControlLabel, FormGroup, Grid } from '@mui/material'
import PrimaryButton from '../../primaryButton/PrimaryButton'

import Indicators from '../../indicators/Indicators'
import useValidation from '../../../hooks/useValidation'
import CustomInpuText from '../../customInputText/CustomInputText'
import YesyNoRadioGroup from '../../yesNoRadioGroup/YesNoRadioGroup'

import { useStyles } from './styles'

const Step2 = ({
  btnAction,
  handleGoto,
  handleChange,
  handleInputChange,
  data,
  cantItems,
  current,
}) => {
  const classes = useStyles()

  const checks = [
    'Accounting',
    'Building Maintenance / Janitorial',
    'Landscaping / Irrigation / Pest Control',
    'Property Management',
    'Proposal',
    'Sales and Lease',
    'Other',
  ]

  const countServices = (svs) => {
    return Object.keys(svs).filter((name) => svs[name]).length
  }

  const isServiceSelected = (service) => {
    return (
      Object.keys(data.services).includes(service) && data.services[service]
    )
  }

  const validationSchema = {
    services: {
      valid: data?.services ? countServices(data.services) > 0 : false,
      errorMsg: 'Please select at least one service.',
      validate: (svs) => countServices(svs) > 0,
    },
    otherService: {
      valid: data?.services?.Other ? data.otherService || false : true,
      errorMsg: 'Please fill this field.',
      validate: (value) => (data?.services?.Other ? value || false : true),
    },
    whyNotSatisfied: {
      valid:
        isServiceSelected('Landscaping / Irrigation / Pest Control') &&
        data?.satisfied === 'false'
          ? data.whyNotSatisfied || false
          : true,
      errorMsg: 'Please fill this field.',
      validate: (value) =>
        isServiceSelected('Landscaping / Irrigation / Pest Control') &&
        data?.satisfied === 'false'
          ? value || false
          : true,
    },
  }

  const { errors, validate, validateAll } = useValidation(validationSchema)

  const handleInternalChange = (evt) => {
    const { name, value } = evt.target
    handleChange(evt)
    const svs = { ...data.services }
    validate('services', { ...svs, [name]: value })
  }

  const handleInternalInputChange = (evt) => {
    const { name, value } = evt.target
    handleInputChange(evt)
    validate(name, value)
  }

  const handleInternalBtnAction = (evt) => {
    if (validateAll()) {
      btnAction(evt)
    }
  }

  const handleInternalGoto = (index) => {
    if (index < data.step || validateAll()) {
      handleGoto(index)
    }
  }

  return (
    <Grid container spacing={2} className={classes.wrapper}>
      <Grid item xs={12}>
        <p className={classes.formTitle}>
          What Services do you currently receive with Seacrest Services?
        </p>
        {errors?.services && <p className='text-error'>{errors?.services}</p>}
      </Grid>
      <Grid item xs={12}>
        <FormGroup>
          {checks.map((item, index) => (
            <FormControlLabel
              key={`chck-${index}`}
              control={
                <Checkbox
                  name={item}
                  checked={data.services[item] || false}
                  onChange={handleInternalChange}
                />
              }
              label={item}
            />
          ))}
        </FormGroup>
      </Grid>
      {data.services?.Other && (
        <Grid item xs={12}>
          <CustomInpuText
            label='Other Service'
            name='otherService'
            value={data.otherService || ''}
            onChange={handleInternalInputChange}
            required
            error={errors?.otherService ? true : false}
            helperText={errors?.otherService || ''}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <YesyNoRadioGroup
          title='Does your feedback today pertain to a Work Order?'
          name='isWorkOrder'
          value={data.isWorkOrder}
          onChange={handleInternalInputChange}
        />
      </Grid>
      {isServiceSelected('Landscaping / Irrigation / Pest Control') && (
        <>
          <Grid item xs={12}>
            <YesyNoRadioGroup
              title='Are you satisfied with the completion status of your request?'
              name='satisfied'
              value={data.satisfied}
              onChange={handleInternalInputChange}
            />
          </Grid>
          {data.satisfied === 'false' && (
            <Grid item xs={12}>
              <CustomInpuText
                label='Could you please explain?'
                multiline
                required
                rows={3}
                name='whyNotSatisfied'
                value={data.whyNotSatisfied}
                onChange={handleInternalInputChange}
                error={errors?.whyNotSatisfied ? true : false}
                helperText={errors?.whyNotSatisfied || ''}
              />
            </Grid>
          )}
        </>
      )}
      {isServiceSelected('Proposal') && (
        <Grid item xs={12}>
          <YesyNoRadioGroup
            title='Are you interested in receiving a proposal for our services?'
            name='interestedInRecieveProposal'
            value={data.interestedInRecieveProposal}
            onChange={handleInternalInputChange}
          />
        </Grid>
      )}
      <Grid
        container
        item
        xs={12}
        sm={6}
        lg={6}
        justifyContent='center'
        alignItems='flex-end'
        sx={{ display: { sm: 'none', xs: 'flex' } }}
      >
        <Indicators
          cantItems={cantItems}
          current={current}
          handleGoto={handleInternalGoto}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={6} className={classes.btnWrapper}>
        <PrimaryButton onClick={handleInternalBtnAction}>Next</PrimaryButton>
      </Grid>
      <Grid
        container
        item
        xs={12}
        sm={6}
        lg={6}
        justifyContent='flex-end'
        alignItems='flex-end'
        sx={{ display: { sm: 'flex', xs: 'none' } }}
      >
        <Indicators
          cantItems={cantItems}
          current={current}
          handleGoto={handleInternalGoto}
        />
      </Grid>
    </Grid>
  )
}

export default Step2
